import "./js/mobile-menu";
import "./js/collapsible-menu";
import "./js/header-menu";
import "./js/header-shadow-after-scroll";
import "./js/pricing-pdf-selector";
import "./js/language-toggler";
